"use strict"; ///////////////////////////////////////////////////////////////////////////////
//
// Licensed under the Apache License, Version 2.0  ( the  "License" );  you may 
// not use this file except in compliance with the License.  You may  obtain  a 
// copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required  by  applicable  law  or  agreed  to  in  writing,  software 
// distributed under the License is distributed on an "AS  IS"  BASIS,  WITHOUT
// WARRANTIES OR CONDITIONS  OF  ANY  KIND, either express or implied.  See the 
// License for the specific  language  governing  permissions  and  limitations 
// under the License.

var _regeneratorRuntime = require("/home/user/RiderProjects/KernelManagementLab/Universe.W3Top/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(Forward),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(Reverse),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(Select),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(DefaultIfEmpty),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(ChunkBy),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(Distinct),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(DistinctFast),
    _marked8 =
/*#__PURE__*/
_regeneratorRuntime.mark(OfType),
    _marked9 =
/*#__PURE__*/
_regeneratorRuntime.mark(Where),
    _marked10 =
/*#__PURE__*/
_regeneratorRuntime.mark(Skip),
    _marked11 =
/*#__PURE__*/
_regeneratorRuntime.mark(SkipWhile),
    _marked12 =
/*#__PURE__*/
_regeneratorRuntime.mark(TakeWhile),
    _marked13 =
/*#__PURE__*/
_regeneratorRuntime.mark(Intersect),
    _marked14 =
/*#__PURE__*/
_regeneratorRuntime.mark(Repeat),
    _marked15 =
/*#__PURE__*/
_regeneratorRuntime.mark(Range),
    _marked16 =
/*#__PURE__*/
_regeneratorRuntime.mark(Union),
    _marked17 =
/*#__PURE__*/
_regeneratorRuntime.mark(UnionFast),
    _marked18 =
/*#__PURE__*/
_regeneratorRuntime.mark(Join),
    _marked19 =
/*#__PURE__*/
_regeneratorRuntime.mark(GroupJoin),
    _marked20 =
/*#__PURE__*/
_regeneratorRuntime.mark(GroupBy),
    _marked21 =
/*#__PURE__*/
_regeneratorRuntime.mark(SelectMany),
    _marked22 =
/*#__PURE__*/
_regeneratorRuntime.mark(Concat),
    _marked23 =
/*#__PURE__*/
_regeneratorRuntime.mark(Zip);

Object.defineProperty(exports, "__esModule", {
  value: true
});

function Forward(target) {
  return _regeneratorRuntime.wrap(function Forward$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield(target, "t0", 1);

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

exports.Forward = Forward;

function Reverse(target) {
  var i;
  return _regeneratorRuntime.wrap(function Reverse$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          i = target.length - 1;

        case 1:
          if (!(i >= 0)) {
            _context2.next = 7;
            break;
          }

          _context2.next = 4;
          return target[i];

        case 4:
          i--;
          _context2.next = 1;
          break;

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

exports.Reverse = Reverse;

function Select(target, transform) {
  var index, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value;

  return _regeneratorRuntime.wrap(function Select$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          index = 0;
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context3.prev = 4;
          _iterator = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context3.next = 13;
            break;
          }

          value = _step.value;
          _context3.next = 10;
          return transform(value, index++);

        case 10:
          _iteratorNormalCompletion = true;
          _context3.next = 6;
          break;

        case 13:
          _context3.next = 19;
          break;

        case 15:
          _context3.prev = 15;
          _context3.t0 = _context3["catch"](4);
          _didIteratorError = true;
          _iteratorError = _context3.t0;

        case 19:
          _context3.prev = 19;
          _context3.prev = 20;

          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }

        case 22:
          _context3.prev = 22;

          if (!_didIteratorError) {
            _context3.next = 25;
            break;
          }

          throw _iteratorError;

        case 25:
          return _context3.finish(22);

        case 26:
          return _context3.finish(19);

        case 27:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[4, 15, 19, 27], [20,, 22, 26]]);
}

exports.Select = Select;

function DefaultIfEmpty(target, defaultValue) {
  var iterator, result;
  return _regeneratorRuntime.wrap(function DefaultIfEmpty$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          iterator = target[Symbol.iterator]();
          result = iterator.next();

          if (!result.done) {
            _context4.next = 7;
            break;
          }

          _context4.next = 5;
          return defaultValue;

        case 5:
          _context4.next = 8;
          break;

        case 7:
          return _context4.delegateYield(target, "t0", 8);

        case 8:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

exports.DefaultIfEmpty = DefaultIfEmpty;

function ChunkBy(target, keySelect, elementSelector, resultSelector) {
  var key, box, i, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, value, newKey;

  return _regeneratorRuntime.wrap(function ChunkBy$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          i = 0;
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context5.prev = 4;
          _iterator2 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context5.next = 19;
            break;
          }

          value = _step2.value;
          newKey = keySelect(value, i++);

          if (!(key !== newKey && box)) {
            _context5.next = 13;
            break;
          }

          _context5.next = 12;
          return resultSelector(key, box);

        case 12:
          box = undefined;

        case 13:
          if (!box) {
            box = new Array();
          }

          key = newKey;
          box.push(elementSelector(value));

        case 16:
          _iteratorNormalCompletion2 = true;
          _context5.next = 6;
          break;

        case 19:
          _context5.next = 25;
          break;

        case 21:
          _context5.prev = 21;
          _context5.t0 = _context5["catch"](4);
          _didIteratorError2 = true;
          _iteratorError2 = _context5.t0;

        case 25:
          _context5.prev = 25;
          _context5.prev = 26;

          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }

        case 28:
          _context5.prev = 28;

          if (!_didIteratorError2) {
            _context5.next = 31;
            break;
          }

          throw _iteratorError2;

        case 31:
          return _context5.finish(28);

        case 32:
          return _context5.finish(25);

        case 33:
          if (!box) {
            _context5.next = 36;
            break;
          }

          _context5.next = 36;
          return resultSelector(key, box);

        case 36:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[4, 21, 25, 33], [26,, 28, 32]]);
}

exports.ChunkBy = ChunkBy;

function Distinct(target, keySelector) {
  var set, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, value, key;

  return _regeneratorRuntime.wrap(function Distinct$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          set = new Set();
          _iteratorNormalCompletion3 = true;
          _didIteratorError3 = false;
          _iteratorError3 = undefined;
          _context6.prev = 4;
          _iterator3 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
            _context6.next = 17;
            break;
          }

          value = _step3.value;
          key = keySelector(value);

          if (!set.has(key)) {
            _context6.next = 11;
            break;
          }

          return _context6.abrupt("continue", 14);

        case 11:
          set.add(key);
          _context6.next = 14;
          return value;

        case 14:
          _iteratorNormalCompletion3 = true;
          _context6.next = 6;
          break;

        case 17:
          _context6.next = 23;
          break;

        case 19:
          _context6.prev = 19;
          _context6.t0 = _context6["catch"](4);
          _didIteratorError3 = true;
          _iteratorError3 = _context6.t0;

        case 23:
          _context6.prev = 23;
          _context6.prev = 24;

          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }

        case 26:
          _context6.prev = 26;

          if (!_didIteratorError3) {
            _context6.next = 29;
            break;
          }

          throw _iteratorError3;

        case 29:
          return _context6.finish(26);

        case 30:
          return _context6.finish(23);

        case 31:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[4, 19, 23, 31], [24,, 26, 30]]);
}

exports.Distinct = Distinct;

function DistinctFast(target) {
  var set, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, value;

  return _regeneratorRuntime.wrap(function DistinctFast$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          set = new Set();
          _iteratorNormalCompletion4 = true;
          _didIteratorError4 = false;
          _iteratorError4 = undefined;
          _context7.prev = 4;
          _iterator4 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
            _context7.next = 16;
            break;
          }

          value = _step4.value;

          if (!set.has(value)) {
            _context7.next = 10;
            break;
          }

          return _context7.abrupt("continue", 13);

        case 10:
          set.add(value);
          _context7.next = 13;
          return value;

        case 13:
          _iteratorNormalCompletion4 = true;
          _context7.next = 6;
          break;

        case 16:
          _context7.next = 22;
          break;

        case 18:
          _context7.prev = 18;
          _context7.t0 = _context7["catch"](4);
          _didIteratorError4 = true;
          _iteratorError4 = _context7.t0;

        case 22:
          _context7.prev = 22;
          _context7.prev = 23;

          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }

        case 25:
          _context7.prev = 25;

          if (!_didIteratorError4) {
            _context7.next = 28;
            break;
          }

          throw _iteratorError4;

        case 28:
          return _context7.finish(25);

        case 29:
          return _context7.finish(22);

        case 30:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[4, 18, 22, 30], [23,, 25, 29]]);
}

exports.DistinctFast = DistinctFast;

function OfType(target, obj, typeName) {
  var _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, value, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, _value;

  return _regeneratorRuntime.wrap(function OfType$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (!typeName) {
            _context8.next = 35;
            break;
          }

          _iteratorNormalCompletion5 = true;
          _didIteratorError5 = false;
          _iteratorError5 = undefined;
          _context8.prev = 4;
          _iterator5 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
            _context8.next = 19;
            break;
          }

          value = _step5.value;

          if (!(typeName == typeof value)) {
            _context8.next = 13;
            break;
          }

          _context8.next = 11;
          return value;

        case 11:
          _context8.next = 16;
          break;

        case 13:
          if (!(value instanceof obj)) {
            _context8.next = 16;
            break;
          }

          _context8.next = 16;
          return value;

        case 16:
          _iteratorNormalCompletion5 = true;
          _context8.next = 6;
          break;

        case 19:
          _context8.next = 25;
          break;

        case 21:
          _context8.prev = 21;
          _context8.t0 = _context8["catch"](4);
          _didIteratorError5 = true;
          _iteratorError5 = _context8.t0;

        case 25:
          _context8.prev = 25;
          _context8.prev = 26;

          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }

        case 28:
          _context8.prev = 28;

          if (!_didIteratorError5) {
            _context8.next = 31;
            break;
          }

          throw _iteratorError5;

        case 31:
          return _context8.finish(28);

        case 32:
          return _context8.finish(25);

        case 33:
          _context8.next = 62;
          break;

        case 35:
          _iteratorNormalCompletion6 = true;
          _didIteratorError6 = false;
          _iteratorError6 = undefined;
          _context8.prev = 38;
          _iterator6 = target[Symbol.iterator]();

        case 40:
          if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
            _context8.next = 48;
            break;
          }

          _value = _step6.value;

          if (!(_value instanceof obj)) {
            _context8.next = 45;
            break;
          }

          _context8.next = 45;
          return _value;

        case 45:
          _iteratorNormalCompletion6 = true;
          _context8.next = 40;
          break;

        case 48:
          _context8.next = 54;
          break;

        case 50:
          _context8.prev = 50;
          _context8.t1 = _context8["catch"](38);
          _didIteratorError6 = true;
          _iteratorError6 = _context8.t1;

        case 54:
          _context8.prev = 54;
          _context8.prev = 55;

          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }

        case 57:
          _context8.prev = 57;

          if (!_didIteratorError6) {
            _context8.next = 60;
            break;
          }

          throw _iteratorError6;

        case 60:
          return _context8.finish(57);

        case 61:
          return _context8.finish(54);

        case 62:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[4, 21, 25, 33], [26,, 28, 32], [38, 50, 54, 62], [55,, 57, 61]]);
}

exports.OfType = OfType;

function Where(target, predicate) {
  var index, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, value;

  return _regeneratorRuntime.wrap(function Where$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          index = 0;
          _iteratorNormalCompletion7 = true;
          _didIteratorError7 = false;
          _iteratorError7 = undefined;
          _context9.prev = 4;
          _iterator7 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
            _context9.next = 15;
            break;
          }

          value = _step7.value;

          if (predicate(value, index++)) {
            _context9.next = 10;
            break;
          }

          return _context9.abrupt("continue", 12);

        case 10:
          _context9.next = 12;
          return value;

        case 12:
          _iteratorNormalCompletion7 = true;
          _context9.next = 6;
          break;

        case 15:
          _context9.next = 21;
          break;

        case 17:
          _context9.prev = 17;
          _context9.t0 = _context9["catch"](4);
          _didIteratorError7 = true;
          _iteratorError7 = _context9.t0;

        case 21:
          _context9.prev = 21;
          _context9.prev = 22;

          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }

        case 24:
          _context9.prev = 24;

          if (!_didIteratorError7) {
            _context9.next = 27;
            break;
          }

          throw _iteratorError7;

        case 27:
          return _context9.finish(24);

        case 28:
          return _context9.finish(21);

        case 29:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9, null, [[4, 17, 21, 29], [22,, 24, 28]]);
}

exports.Where = Where;

function Skip(target, skip) {
  var index, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, value;

  return _regeneratorRuntime.wrap(function Skip$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          index = 0;
          _iteratorNormalCompletion8 = true;
          _didIteratorError8 = false;
          _iteratorError8 = undefined;
          _context10.prev = 4;
          _iterator8 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
            _context10.next = 15;
            break;
          }

          value = _step8.value;

          if (!(skip > index++)) {
            _context10.next = 10;
            break;
          }

          return _context10.abrupt("continue", 12);

        case 10:
          _context10.next = 12;
          return value;

        case 12:
          _iteratorNormalCompletion8 = true;
          _context10.next = 6;
          break;

        case 15:
          _context10.next = 21;
          break;

        case 17:
          _context10.prev = 17;
          _context10.t0 = _context10["catch"](4);
          _didIteratorError8 = true;
          _iteratorError8 = _context10.t0;

        case 21:
          _context10.prev = 21;
          _context10.prev = 22;

          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }

        case 24:
          _context10.prev = 24;

          if (!_didIteratorError8) {
            _context10.next = 27;
            break;
          }

          throw _iteratorError8;

        case 27:
          return _context10.finish(24);

        case 28:
          return _context10.finish(21);

        case 29:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10, null, [[4, 17, 21, 29], [22,, 24, 28]]);
}

exports.Skip = Skip;

function SkipWhile(target, predicate) {
  var index, skipped, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, value;

  return _regeneratorRuntime.wrap(function SkipWhile$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          index = 0, skipped = false;
          _iteratorNormalCompletion9 = true;
          _didIteratorError9 = false;
          _iteratorError9 = undefined;
          _context11.prev = 4;
          _iterator9 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
            _context11.next = 15;
            break;
          }

          value = _step9.value;

          if (!(!skipped && !(skipped = !predicate(value, index++)))) {
            _context11.next = 10;
            break;
          }

          return _context11.abrupt("continue", 12);

        case 10:
          _context11.next = 12;
          return value;

        case 12:
          _iteratorNormalCompletion9 = true;
          _context11.next = 6;
          break;

        case 15:
          _context11.next = 21;
          break;

        case 17:
          _context11.prev = 17;
          _context11.t0 = _context11["catch"](4);
          _didIteratorError9 = true;
          _iteratorError9 = _context11.t0;

        case 21:
          _context11.prev = 21;
          _context11.prev = 22;

          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }

        case 24:
          _context11.prev = 24;

          if (!_didIteratorError9) {
            _context11.next = 27;
            break;
          }

          throw _iteratorError9;

        case 27:
          return _context11.finish(24);

        case 28:
          return _context11.finish(21);

        case 29:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11, null, [[4, 17, 21, 29], [22,, 24, 28]]);
}

exports.SkipWhile = SkipWhile;

function TakeWhile(target, predicate) {
  var index, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, value;

  return _regeneratorRuntime.wrap(function TakeWhile$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          index = 0;
          _iteratorNormalCompletion10 = true;
          _didIteratorError10 = false;
          _iteratorError10 = undefined;
          _context12.prev = 4;
          _iterator10 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
            _context12.next = 15;
            break;
          }

          value = _step10.value;

          if (predicate(value, index++)) {
            _context12.next = 10;
            break;
          }

          return _context12.abrupt("break", 15);

        case 10:
          _context12.next = 12;
          return value;

        case 12:
          _iteratorNormalCompletion10 = true;
          _context12.next = 6;
          break;

        case 15:
          _context12.next = 21;
          break;

        case 17:
          _context12.prev = 17;
          _context12.t0 = _context12["catch"](4);
          _didIteratorError10 = true;
          _iteratorError10 = _context12.t0;

        case 21:
          _context12.prev = 21;
          _context12.prev = 22;

          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }

        case 24:
          _context12.prev = 24;

          if (!_didIteratorError10) {
            _context12.next = 27;
            break;
          }

          throw _iteratorError10;

        case 27:
          return _context12.finish(24);

        case 28:
          return _context12.finish(21);

        case 29:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12, null, [[4, 17, 21, 29], [22,, 24, 28]]);
}

exports.TakeWhile = TakeWhile;

function Intersect(target, exceptions, condition, keySelect) {
  var _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, value, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _value2;

  return _regeneratorRuntime.wrap(function Intersect$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          if (!keySelect) {
            _context13.next = 31;
            break;
          }

          _iteratorNormalCompletion11 = true;
          _didIteratorError11 = false;
          _iteratorError11 = undefined;
          _context13.prev = 4;
          _iterator11 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
            _context13.next = 15;
            break;
          }

          value = _step11.value;

          if (!(condition == exceptions.has(keySelect(value)))) {
            _context13.next = 10;
            break;
          }

          return _context13.abrupt("continue", 12);

        case 10:
          _context13.next = 12;
          return value;

        case 12:
          _iteratorNormalCompletion11 = true;
          _context13.next = 6;
          break;

        case 15:
          _context13.next = 21;
          break;

        case 17:
          _context13.prev = 17;
          _context13.t0 = _context13["catch"](4);
          _didIteratorError11 = true;
          _iteratorError11 = _context13.t0;

        case 21:
          _context13.prev = 21;
          _context13.prev = 22;

          if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
            _iterator11.return();
          }

        case 24:
          _context13.prev = 24;

          if (!_didIteratorError11) {
            _context13.next = 27;
            break;
          }

          throw _iteratorError11;

        case 27:
          return _context13.finish(24);

        case 28:
          return _context13.finish(21);

        case 29:
          _context13.next = 59;
          break;

        case 31:
          _iteratorNormalCompletion12 = true;
          _didIteratorError12 = false;
          _iteratorError12 = undefined;
          _context13.prev = 34;
          _iterator12 = target[Symbol.iterator]();

        case 36:
          if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
            _context13.next = 45;
            break;
          }

          _value2 = _step12.value;

          if (!(condition == exceptions.has(_value2))) {
            _context13.next = 40;
            break;
          }

          return _context13.abrupt("continue", 42);

        case 40:
          _context13.next = 42;
          return _value2;

        case 42:
          _iteratorNormalCompletion12 = true;
          _context13.next = 36;
          break;

        case 45:
          _context13.next = 51;
          break;

        case 47:
          _context13.prev = 47;
          _context13.t1 = _context13["catch"](34);
          _didIteratorError12 = true;
          _iteratorError12 = _context13.t1;

        case 51:
          _context13.prev = 51;
          _context13.prev = 52;

          if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
            _iterator12.return();
          }

        case 54:
          _context13.prev = 54;

          if (!_didIteratorError12) {
            _context13.next = 57;
            break;
          }

          throw _iteratorError12;

        case 57:
          return _context13.finish(54);

        case 58:
          return _context13.finish(51);

        case 59:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13, null, [[4, 17, 21, 29], [22,, 24, 28], [34, 47, 51, 59], [52,, 54, 58]]);
}

exports.Intersect = Intersect;

function Repeat(value, count) {
  var i;
  return _regeneratorRuntime.wrap(function Repeat$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          i = 0;

        case 1:
          if (!(i < count)) {
            _context14.next = 7;
            break;
          }

          _context14.next = 4;
          return value;

        case 4:
          i++;
          _context14.next = 1;
          break;

        case 7:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}

exports.Repeat = Repeat;

function Range(value, count) {
  var current, i;
  return _regeneratorRuntime.wrap(function Range$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          current = value;
          i = 0;

        case 2:
          if (!(i < count)) {
            _context15.next = 9;
            break;
          }

          _context15.next = 5;
          return current;

        case 5:
          current++;

        case 6:
          i++;
          _context15.next = 2;
          break;

        case 9:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}

exports.Range = Range;

function Union(first, second, keySelector) {
  var set, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, value, key, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, _value3, _key;

  return _regeneratorRuntime.wrap(function Union$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          set = new Set();
          _iteratorNormalCompletion13 = true;
          _didIteratorError13 = false;
          _iteratorError13 = undefined;
          _context16.prev = 4;
          _iterator13 = first[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
            _context16.next = 17;
            break;
          }

          value = _step13.value;
          key = keySelector(value);

          if (!set.has(key)) {
            _context16.next = 11;
            break;
          }

          return _context16.abrupt("continue", 14);

        case 11:
          set.add(key);
          _context16.next = 14;
          return value;

        case 14:
          _iteratorNormalCompletion13 = true;
          _context16.next = 6;
          break;

        case 17:
          _context16.next = 23;
          break;

        case 19:
          _context16.prev = 19;
          _context16.t0 = _context16["catch"](4);
          _didIteratorError13 = true;
          _iteratorError13 = _context16.t0;

        case 23:
          _context16.prev = 23;
          _context16.prev = 24;

          if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
            _iterator13.return();
          }

        case 26:
          _context16.prev = 26;

          if (!_didIteratorError13) {
            _context16.next = 29;
            break;
          }

          throw _iteratorError13;

        case 29:
          return _context16.finish(26);

        case 30:
          return _context16.finish(23);

        case 31:
          _iteratorNormalCompletion14 = true;
          _didIteratorError14 = false;
          _iteratorError14 = undefined;
          _context16.prev = 34;
          _iterator14 = second[Symbol.iterator]();

        case 36:
          if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
            _context16.next = 47;
            break;
          }

          _value3 = _step14.value;
          _key = keySelector(_value3);

          if (!set.has(_key)) {
            _context16.next = 41;
            break;
          }

          return _context16.abrupt("continue", 44);

        case 41:
          set.add(_key);
          _context16.next = 44;
          return _value3;

        case 44:
          _iteratorNormalCompletion14 = true;
          _context16.next = 36;
          break;

        case 47:
          _context16.next = 53;
          break;

        case 49:
          _context16.prev = 49;
          _context16.t1 = _context16["catch"](34);
          _didIteratorError14 = true;
          _iteratorError14 = _context16.t1;

        case 53:
          _context16.prev = 53;
          _context16.prev = 54;

          if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
            _iterator14.return();
          }

        case 56:
          _context16.prev = 56;

          if (!_didIteratorError14) {
            _context16.next = 59;
            break;
          }

          throw _iteratorError14;

        case 59:
          return _context16.finish(56);

        case 60:
          return _context16.finish(53);

        case 61:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked16, null, [[4, 19, 23, 31], [24,, 26, 30], [34, 49, 53, 61], [54,, 56, 60]]);
}

exports.Union = Union;

function UnionFast(first, second) {
  var set, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _iterator15, _step15, value, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, _value4;

  return _regeneratorRuntime.wrap(function UnionFast$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          set = new Set();
          _iteratorNormalCompletion15 = true;
          _didIteratorError15 = false;
          _iteratorError15 = undefined;
          _context17.prev = 4;
          _iterator15 = first[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done) {
            _context17.next = 16;
            break;
          }

          value = _step15.value;

          if (!set.has(value)) {
            _context17.next = 10;
            break;
          }

          return _context17.abrupt("continue", 13);

        case 10:
          set.add(value);
          _context17.next = 13;
          return value;

        case 13:
          _iteratorNormalCompletion15 = true;
          _context17.next = 6;
          break;

        case 16:
          _context17.next = 22;
          break;

        case 18:
          _context17.prev = 18;
          _context17.t0 = _context17["catch"](4);
          _didIteratorError15 = true;
          _iteratorError15 = _context17.t0;

        case 22:
          _context17.prev = 22;
          _context17.prev = 23;

          if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
            _iterator15.return();
          }

        case 25:
          _context17.prev = 25;

          if (!_didIteratorError15) {
            _context17.next = 28;
            break;
          }

          throw _iteratorError15;

        case 28:
          return _context17.finish(25);

        case 29:
          return _context17.finish(22);

        case 30:
          _iteratorNormalCompletion16 = true;
          _didIteratorError16 = false;
          _iteratorError16 = undefined;
          _context17.prev = 33;
          _iterator16 = second[Symbol.iterator]();

        case 35:
          if (_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done) {
            _context17.next = 45;
            break;
          }

          _value4 = _step16.value;

          if (!set.has(_value4)) {
            _context17.next = 39;
            break;
          }

          return _context17.abrupt("continue", 42);

        case 39:
          set.add(_value4);
          _context17.next = 42;
          return _value4;

        case 42:
          _iteratorNormalCompletion16 = true;
          _context17.next = 35;
          break;

        case 45:
          _context17.next = 51;
          break;

        case 47:
          _context17.prev = 47;
          _context17.t1 = _context17["catch"](33);
          _didIteratorError16 = true;
          _iteratorError16 = _context17.t1;

        case 51:
          _context17.prev = 51;
          _context17.prev = 52;

          if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
            _iterator16.return();
          }

        case 54:
          _context17.prev = 54;

          if (!_didIteratorError16) {
            _context17.next = 57;
            break;
          }

          throw _iteratorError16;

        case 57:
          return _context17.finish(54);

        case 58:
          return _context17.finish(51);

        case 59:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked17, null, [[4, 18, 22, 30], [23,, 25, 29], [33, 47, 51, 59], [52,, 54, 58]]);
}

exports.UnionFast = UnionFast;

function Join(target, oKeySelect, transform, map) {
  var _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _iterator17, _step17, value, key, innerSet, _iteratorNormalCompletion18, _didIteratorError18, _iteratorError18, _iterator18, _step18, inner;

  return _regeneratorRuntime.wrap(function Join$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _iteratorNormalCompletion17 = true;
          _didIteratorError17 = false;
          _iteratorError17 = undefined;
          _context18.prev = 3;
          _iterator17 = target[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done) {
            _context18.next = 42;
            break;
          }

          value = _step17.value;
          key = oKeySelect(value);

          if (key) {
            _context18.next = 10;
            break;
          }

          return _context18.abrupt("continue", 39);

        case 10:
          innerSet = map.get(key);

          if (innerSet) {
            _context18.next = 13;
            break;
          }

          return _context18.abrupt("continue", 39);

        case 13:
          _iteratorNormalCompletion18 = true;
          _didIteratorError18 = false;
          _iteratorError18 = undefined;
          _context18.prev = 16;
          _iterator18 = innerSet[Symbol.iterator]();

        case 18:
          if (_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done) {
            _context18.next = 25;
            break;
          }

          inner = _step18.value;
          _context18.next = 22;
          return transform(value, inner);

        case 22:
          _iteratorNormalCompletion18 = true;
          _context18.next = 18;
          break;

        case 25:
          _context18.next = 31;
          break;

        case 27:
          _context18.prev = 27;
          _context18.t0 = _context18["catch"](16);
          _didIteratorError18 = true;
          _iteratorError18 = _context18.t0;

        case 31:
          _context18.prev = 31;
          _context18.prev = 32;

          if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
            _iterator18.return();
          }

        case 34:
          _context18.prev = 34;

          if (!_didIteratorError18) {
            _context18.next = 37;
            break;
          }

          throw _iteratorError18;

        case 37:
          return _context18.finish(34);

        case 38:
          return _context18.finish(31);

        case 39:
          _iteratorNormalCompletion17 = true;
          _context18.next = 5;
          break;

        case 42:
          _context18.next = 48;
          break;

        case 44:
          _context18.prev = 44;
          _context18.t1 = _context18["catch"](3);
          _didIteratorError17 = true;
          _iteratorError17 = _context18.t1;

        case 48:
          _context18.prev = 48;
          _context18.prev = 49;

          if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
            _iterator17.return();
          }

        case 51:
          _context18.prev = 51;

          if (!_didIteratorError17) {
            _context18.next = 54;
            break;
          }

          throw _iteratorError17;

        case 54:
          return _context18.finish(51);

        case 55:
          return _context18.finish(48);

        case 56:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked18, null, [[3, 44, 48, 56], [16, 27, 31, 39], [32,, 34, 38], [49,, 51, 55]]);
}

exports.Join = Join;

function GroupJoin(target, oKeySelect, transform, map) {
  var _iteratorNormalCompletion19, _didIteratorError19, _iteratorError19, _iterator19, _step19, value, innerSet, key;

  return _regeneratorRuntime.wrap(function GroupJoin$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _iteratorNormalCompletion19 = true;
          _didIteratorError19 = false;
          _iteratorError19 = undefined;
          _context19.prev = 3;
          _iterator19 = target[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done) {
            _context19.next = 15;
            break;
          }

          value = _step19.value;
          innerSet = undefined;
          key = oKeySelect(value);

          if (key) {
            innerSet = map.get(key);
          }

          _context19.next = 12;
          return transform(value, innerSet);

        case 12:
          _iteratorNormalCompletion19 = true;
          _context19.next = 5;
          break;

        case 15:
          _context19.next = 21;
          break;

        case 17:
          _context19.prev = 17;
          _context19.t0 = _context19["catch"](3);
          _didIteratorError19 = true;
          _iteratorError19 = _context19.t0;

        case 21:
          _context19.prev = 21;
          _context19.prev = 22;

          if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
            _iterator19.return();
          }

        case 24:
          _context19.prev = 24;

          if (!_didIteratorError19) {
            _context19.next = 27;
            break;
          }

          throw _iteratorError19;

        case 27:
          return _context19.finish(24);

        case 28:
          return _context19.finish(21);

        case 29:
        case "end":
          return _context19.stop();
      }
    }
  }, _marked19, null, [[3, 17, 21, 29], [22,, 24, 28]]);
}

exports.GroupJoin = GroupJoin;

function GroupBy(map, resultSelect) {
  var _iteratorNormalCompletion20, _didIteratorError20, _iteratorError20, _iterator20, _step20, key;

  return _regeneratorRuntime.wrap(function GroupBy$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _iteratorNormalCompletion20 = true;
          _didIteratorError20 = false;
          _iteratorError20 = undefined;
          _context20.prev = 3;
          _iterator20 = map.keys()[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done) {
            _context20.next = 12;
            break;
          }

          key = _step20.value;
          _context20.next = 9;
          return resultSelect(key, map.get(key));

        case 9:
          _iteratorNormalCompletion20 = true;
          _context20.next = 5;
          break;

        case 12:
          _context20.next = 18;
          break;

        case 14:
          _context20.prev = 14;
          _context20.t0 = _context20["catch"](3);
          _didIteratorError20 = true;
          _iteratorError20 = _context20.t0;

        case 18:
          _context20.prev = 18;
          _context20.prev = 19;

          if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
            _iterator20.return();
          }

        case 21:
          _context20.prev = 21;

          if (!_didIteratorError20) {
            _context20.next = 24;
            break;
          }

          throw _iteratorError20;

        case 24:
          return _context20.finish(21);

        case 25:
          return _context20.finish(18);

        case 26:
        case "end":
          return _context20.stop();
      }
    }
  }, _marked20, null, [[3, 14, 18, 26], [19,, 21, 25]]);
}

exports.GroupBy = GroupBy;

function SelectMany(target, selector, transform) {
  var index, _iteratorNormalCompletion21, _didIteratorError21, _iteratorError21, _iterator21, _step21, item, _iteratorNormalCompletion22, _didIteratorError22, _iteratorError22, _iterator22, _step22, collectionItem;

  return _regeneratorRuntime.wrap(function SelectMany$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          index = 0;
          _iteratorNormalCompletion21 = true;
          _didIteratorError21 = false;
          _iteratorError21 = undefined;
          _context21.prev = 4;
          _iterator21 = target[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done) {
            _context21.next = 37;
            break;
          }

          item = _step21.value;
          _iteratorNormalCompletion22 = true;
          _didIteratorError22 = false;
          _iteratorError22 = undefined;
          _context21.prev = 11;
          _iterator22 = selector(item, index++)[Symbol.iterator]();

        case 13:
          if (_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done) {
            _context21.next = 20;
            break;
          }

          collectionItem = _step22.value;
          _context21.next = 17;
          return transform(item, collectionItem);

        case 17:
          _iteratorNormalCompletion22 = true;
          _context21.next = 13;
          break;

        case 20:
          _context21.next = 26;
          break;

        case 22:
          _context21.prev = 22;
          _context21.t0 = _context21["catch"](11);
          _didIteratorError22 = true;
          _iteratorError22 = _context21.t0;

        case 26:
          _context21.prev = 26;
          _context21.prev = 27;

          if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
            _iterator22.return();
          }

        case 29:
          _context21.prev = 29;

          if (!_didIteratorError22) {
            _context21.next = 32;
            break;
          }

          throw _iteratorError22;

        case 32:
          return _context21.finish(29);

        case 33:
          return _context21.finish(26);

        case 34:
          _iteratorNormalCompletion21 = true;
          _context21.next = 6;
          break;

        case 37:
          _context21.next = 43;
          break;

        case 39:
          _context21.prev = 39;
          _context21.t1 = _context21["catch"](4);
          _didIteratorError21 = true;
          _iteratorError21 = _context21.t1;

        case 43:
          _context21.prev = 43;
          _context21.prev = 44;

          if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
            _iterator21.return();
          }

        case 46:
          _context21.prev = 46;

          if (!_didIteratorError21) {
            _context21.next = 49;
            break;
          }

          throw _iteratorError21;

        case 49:
          return _context21.finish(46);

        case 50:
          return _context21.finish(43);

        case 51:
        case "end":
          return _context21.stop();
      }
    }
  }, _marked21, null, [[4, 39, 43, 51], [11, 22, 26, 34], [27,, 29, 33], [44,, 46, 50]]);
}

exports.SelectMany = SelectMany;

function Concat(target, second) {
  return _regeneratorRuntime.wrap(function Concat$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          return _context22.delegateYield(target, "t0", 1);

        case 1:
          return _context22.delegateYield(second, "t1", 2);

        case 2:
        case "end":
          return _context22.stop();
      }
    }
  }, _marked22);
}

exports.Concat = Concat;

function Zip(first, second, transform) {
  var _index,
      iteratorOne,
      iteratorTwo,
      retOne,
      retTwo,
      _args23 = arguments;

  return _regeneratorRuntime.wrap(function Zip$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _index = _args23.length > 3 && _args23[3] !== undefined ? _args23[3] : 0;
          iteratorOne = first[Symbol.iterator]();
          iteratorTwo = second[Symbol.iterator]();

        case 3:
          if (!(!(retOne = iteratorOne.next()).done && !(retTwo = iteratorTwo.next()).done)) {
            _context23.next = 8;
            break;
          }

          _context23.next = 6;
          return transform(retOne.value, retTwo.value);

        case 6:
          _context23.next = 3;
          break;

        case 8:
        case "end":
          return _context23.stop();
      }
    }
  }, _marked23);
}

exports.Zip = Zip;
/** Copyright (c) ENikS.  All rights reserved. */